<!--
  - Copyright (c) 2018 BarD Software s.r.o
  -->

<template>
    <div class="project-full-history rounded mb-5">
        <div class="header">
            <h4>Full Project History</h4>
        </div>
        <div class="team-info-tab-row align-items-baseline d-flex">
            <h5 class="flex-grow-1">{{ project.name }}</h5>
            <button class="btn btn-attention btn-back-to-projects"
                    v-on:click="closeFullHistory()">
                <i class="fa fa-chevron-left"></i>&nbsp;All Projects
            </button>
        </div>
        <div class="team-info-body mt-3">
            <div class="team-info-body-content">
                <div id="project-history-list" class="w-100 small project-history list-group">
                    <version-item
                            v-for="v in versions"
                            v-bind:key="v.number"
                            v-bind="{'data-version': v.number}"
                            v-bind:version="v"
                            v-bind:project="project"
                            v-bind:glasspane="toggleGlasspane">
                    </version-item>
                    <div class="list-group-item list-group-item-action list-group-item-load-more"
                         v-if="showMoreVersionsButton()"
                    >
                        <div class="d-flex justify-content-center">
                            <button id="more-versions"
                                    class="btn btn-sm btn-secondary"
                                    v-bind:class="{ 'd-none': !showMoreVersionsButton() }"
                                    v-on:click="loadMoreVersions">Load more</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" src="./ProjectHistory.ts"></script>
